// extracted by mini-css-extract-plugin
var _1 = "S5F4h";
var _2 = "NHt8v";
export { _1 as "base", _2 as "headline" }
